const globalSelectors = {
	triggerForm: '.split-banner__trigger-form',
	drawer: '#app-formular-drawer',
	form: '#app-formular',
	hidden: 'is-hidden',
};

const validateFirstStep = (name, email, telephone) => {
	return (
		name.trim() &&
		email.trim() &&
		telephone.trim() &&
		email.includes('@') &&
		email.includes('.') &&
		telephone.length > 8
	);
};

const attachListeners = () => {
	document.querySelectorAll(globalSelectors.triggerForm).forEach((el) => {
		el.onclick = () => {
			const drawer = document.querySelector(globalSelectors.drawer);
			const form = document.querySelector(globalSelectors.form);
			drawer.classList.toggle(globalSelectors.hidden);
			form.classList.toggle(globalSelectors.hidden)
		};
	});
};

export { validateFirstStep, attachListeners };
